<div class="container">
  <div fxLayout fxLayoutGap="36px" fxLayoutAlign="flex-start baseline">
    <ng-template #descriptionTemplate>
      <div class="description-template" [innerHTML]="formatInnerText(cardDescription | linkify)"></div>
    </ng-template>

    <div class='table-title'>{{('CLIENT_PROMISES_TABLE' | translate) }}</div>

    <mat-icon
      class="info-icon"
      [matTooltip]="'OPEN_DESCRIPTION' | translate"
      [matTooltipPosition]="'above'"
      (click)='openDescription(descriptionTemplate)'
    >info</mat-icon>

    <form [formGroup]="dateForm">
      <mat-form-field>
        <mat-label>{{ 'CLIENT_STATS_DATE' | translate }}</mat-label>
        <input matInput
               readonly
               formControlName="dateFrom"
               (click)="pickerDateFrom.open()"
               [matDatepicker]="pickerDateFrom"
               [placeholder]="'CLIENT_STATS_DATE' | translate"
        >
        <mat-datepicker-toggle matSuffix [for]="pickerDateFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerDateFrom disabled="false"></mat-datepicker>
      </mat-form-field>
    </form>
  </div>

  <mat-table [dataSource]="tableData">
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-icon class="is-important" [class.checked]="element?.isImportant" (click)="onStatusChange(element.status, element, true)">
          priority_high
        </mat-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="escalate">
      <mat-header-cell *matHeaderCellDef>{{ 'ESCALATIONS' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="escalation-buttons">
          <div class="escalation-button-container" *ngIf="hasDashboardWithLevel('II') && dashboard?.meetingLevel === 'II'">
            <button
              mat-icon-button
              [class.escalated]="isEscalatedToLevel(element, 'II')"
              [matTooltip]="'ESCALATE_TO_LVL' | translate:{ level: '2' }"
              (click)="$event.stopPropagation(); escalateToLevel(element, 'II')"
              [disabled]="isEscalating"
            >
              <mat-icon>publish</mat-icon>
            </button>
            <span class="level-indicator" [class.escalated]="isEscalatedToLevel(element, 'II')">2LVL</span>
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="order">
      <mat-header-cell *matHeaderCellDef>{{ 'PROJECT' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{'ID' | translate}}: {{ element?.order?.id || '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="position">
      <mat-header-cell *matHeaderCellDef>{{ 'POSITION' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element?.order?.specification?.positionTitle || '-'}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="client">
      <mat-header-cell *matHeaderCellDef>{{ 'CLIENT.CLIENT' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element?.order?.company?.name || element?.company?.name || '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef>{{ 'DATE' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element?.date }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PROMISES_INTRO_CALL_INTERVIEW">
      <mat-header-cell *matHeaderCellDef>
        <div>{{ 'PROMISES_INTRO_CALL_INTERVIEW' | translate }}</div>
        <div class="header-subtitle">{{ 'FACT' | translate }} / {{ 'PLAN' | translate }}</div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="promise-cell"
        [ngClass]="element?.stats['PROMISES_INTRO_CALL_INTERVIEW'] ? getStatCellView(element.statsData?.offeredFromDate, element.stats['PROMISES_INTRO_CALL_INTERVIEW']) : ''"
      >
        {{ element?.statsData?.offeredFromDate || 0 }} / {{
          element?.stats['PROMISES_INTRO_CALL_INTERVIEW'] ? element?.stats['PROMISES_INTRO_CALL_INTERVIEW'] || 0 : 0}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PROMISES_PRESENTED_TO_CLIENT">
      <mat-header-cell *matHeaderCellDef>
        <div>{{ 'PROMISES_PRESENTED_TO_CLIENT' | translate }}</div>
        <div class="header-subtitle">{{ 'FACT' | translate }} / {{ 'PLAN' | translate }}</div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="promise-cell"
        [ngClass]="element?.stats['PROMISES_PRESENTED_TO_CLIENT'] ? getStatCellView(element.statsData?.presentedClient, element.stats['PROMISES_PRESENTED_TO_CLIENT']) : ''"
      >
        {{ element?.statsData?.presentedClient || 0 }} / {{
          element?.stats['PROMISES_PRESENTED_TO_CLIENT'] ? element?.stats['PROMISES_PRESENTED_TO_CLIENT'] || 0 : 0}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PROMISES_CLIENT_INTERVIEW">
      <mat-header-cell *matHeaderCellDef>
        <div>{{ 'PROMISES_CLIENT_INTERVIEW' | translate }}</div>
        <div class="header-subtitle">{{ 'FACT' | translate }} / {{ 'PLAN' | translate }}</div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="promise-cell"
        [ngClass]="element?.stats['PROMISES_CLIENT_INTERVIEW'] ? getStatCellView(element?.statsData?.toBeInterviewedClient, element.stats['PROMISES_CLIENT_INTERVIEW']) : ''"
      >
        {{ element?.statsData?.toBeInterviewedClient || 0 }} / {{
          element?.stats['PROMISES_CLIENT_INTERVIEW'] ? element?.stats['PROMISES_CLIENT_INTERVIEW'] || 0 : 0}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PROMISES_HEALTHCHECK">
      <mat-header-cell *matHeaderCellDef>
        <div>{{ 'PROMISES_HEALTHCHECK' | translate }}</div>
        <div class="header-subtitle">{{ 'FACT' | translate }} / {{ 'PLAN' | translate }}</div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="promise-cell"
        [ngClass]="element?.stats['PROMISES_HEALTHCHECK'] ? getStatCellView(element?.statsData?.healthCheckPending, element?.stats['PROMISES_HEALTHCHECK']) : ''"
      >
        {{ element?.statsData?.healthCheckPending || 0 }} / {{
          element?.stats['PROMISES_HEALTHCHECK'] ? element?.stats['PROMISES_HEALTHCHECK'] || 0 : 0}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PROMISES_CLIENT_EMPLOYED">
      <mat-header-cell *matHeaderCellDef>
        <div>{{ 'PROMISES_CLIENT_EMPLOYED' | translate }}</div>
        <div class="header-subtitle">{{ 'FACT' | translate }} / {{ 'PLAN' | translate }}</div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        class="promise-cell"
        [ngClass]="element?.stats['PROMISES_CLIENT_EMPLOYED'] ? getStatCellView(element?.statsData?.toBeEmployed, element.stats['PROMISES_CLIENT_EMPLOYED']) : ''"
      >
        {{ element?.statsData?.toBeEmployed || 0 }} / {{
          element?.stats['PROMISES_CLIENT_EMPLOYED'] ? element?.stats['PROMISES_CLIENT_EMPLOYED'] || 0 : 0}}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
